import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

import { helpModuleReducer } from "./reducer";
import { HelpModuleType } from "./helpTypes";
import {
  createHelpModuleListAction,
  getHelpModuleListAction,
  updateHelpModuleAction,
} from "./action";

export const helpModuleSlice = createSlice({
  name: "helpModule",
  initialState,
  reducers: helpModuleReducer,
  extraReducers: {
    [createHelpModuleListAction.pending.toString()]: (
      state: HelpModuleType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createHelpModuleListAction.fulfilled.toString()]: (
      state: HelpModuleType,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          addSuccess:success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        addSuccess:success,
        addMessage:message,
      };
    },

    [createHelpModuleListAction.rejected.toString()]: (
      state: HelpModuleType,
      { error }
    ) => ({
      ...state,
      addSuccess: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateHelpModuleAction.pending.toString()]: (state: HelpModuleType) => ({
      ...state,
      fetching: true,
    }),
    [updateHelpModuleAction.fulfilled.toString()]: (
      state: HelpModuleType,
      { payload }
    ) => {
      const { success, status_code, message, result, _id } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          editSuccess:success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        editSuccess:success,
        editMessage:message,
      };
    },

    [updateHelpModuleAction.rejected.toString()]: (
      state: HelpModuleType,
      { error }
    ) => ({
      ...state,
      editSuccess: 0,
      error: error?.message,
      fetching: false,
    }),

    [getHelpModuleListAction.pending.toString()]: (state: HelpModuleType) => ({
      ...state,
      fetching: true,
    }),
    [getHelpModuleListAction.fulfilled.toString()]: (
      state: HelpModuleType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        helpModuleList: result,
        statusCode: status_code,
        helpModuleTotalCount: total_count,
        message,
      };
    },
    [getHelpModuleListAction.rejected.toString()]: (
      state: HelpModuleType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
  },
});
export const {
  resetHelpModuleError,
  resetHelpModuleSuccess,
  resetHelpModuleFetching,
  resetHelpModuleMessage,
  resetHelpModuleListing,
  resetHelpModuleListTotal,
  resetHelpModuleStatusCode,
  resetHelpModuleAddMessage,
resetHelpModuleEditMessage,
resetHelpModuleAddSuccess,
resetHelpModuleEditSuccess
} = helpModuleSlice.actions;
